import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Observable }        from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class ElasticSearchService {

    public clearSearchBox = false;
    public searchQuery: any;

    public queryPart_agg: Object;

    public query_search_all = {
        _source: false, 
        sort : ["_score", { date : {order : "desc"}}],
        query: {bool: {
            must: {match_all : {}},
            filter:[]
        }}  
    };

    public query_search_all_nosort = {
        _source: false, 
        query: {bool: {
            must: {match_all : {}},
            filter:[]
        }} 
    };

    constructor(private http: Http) {
        // Initial default query
        this.queryInit();
    }

    queryInit(){
        this.searchQuery = this.query_search_all;
    }

    addFilterActive(filters:any[], val){
        filters.push({
            term: {active: val}
        });
    }

    setAggregationQueryString(fields){
        this.queryPart_agg = this.buildQuery_agg(fields, 10);
        this.searchQuery['aggregations'] = this.queryPart_agg;
    }

    buildQuery_agg(fields: string[], limit: number): Object {
        let query = {};
        for(let f of fields){
            query[f] = {terms : {}};
            query[f]['terms'] =  {field : f+'.raw', size: limit};
        }
        return query;
    }

    private handleError(error: any): Promise<any> {
        console.error('Content API error', error);
        return Promise.reject(error.message || error);
    }

    setFilterQueryString(esFilters: Object[]){
        this.searchQuery.query.bool.filter = esFilters;
    }

    setPaginationQueryString(from: number, size: number){
        if(from==null)
            delete this.searchQuery.from;
        else
            this.searchQuery.from = from;
        if(size==null)
            delete this.searchQuery.size;
        else
            this.searchQuery.size = size;
    }

    clearSearchQueryString(){
        this.searchQuery.query.bool.must = {match_all: {}};
    }

    setSearchQueryString(fields: string[], queryString: string){
      this.queryInit();
      // operator: "and",
      this.searchQuery.query.bool.must = {
        multi_match: {
            query: queryString,
            fields: fields,
            fuzziness: 0
        }
      };
      this.searchQuery['aggregations'] = this.queryPart_agg;
    }

    // target format: {type1: [{name: name1, freq: 2}]} 
    formatSuggestions(suggestions){
        // Compute freq
        let formated = {};
        for(let type in suggestions){
            formated[type] = {};
            for(let s of suggestions[type][0].options){
                if(!formated[type][s.text])
                    formated[type][s.text] = 1;
                else 
                    formated[type][s.text] = formated[type][s.text] + 1;
            }
        }
        // Format in an ordered array of objects
        let sorted:any = {};
        for(let type in formated){
            sorted[type] = [];
            for(let e in formated[type]){
                sorted[type].push({name: e, freq: formated[type][e]});
            }
            sorted[type].sort(function(obj1:any, obj2:any) {
                return obj2.freq - obj1.freq;
            });
        }
        return sorted;
    }

    // private esSearchUrl = 'http://localhost:9200/guerncms/record/_search?pretty';
    // private headers = new Headers({'Content-Type': 'application/json'});
    // suggest(term: string): Observable<any> {
    //     // http://cloud-clinic.blogspot.fr/2016/06/how-to-use-elastic-search-suggester-to.html
    //     let suggest_fields = ['soloist','composer','conductor'];
    //     let query_suggest = {
    //         _source: "suggest",
    //         suggest: {}
    //     };
    //     for(let field of suggest_fields) {
    //         query_suggest.suggest[field+'_suggest'] = {
    //             prefix : term,
    //             completion : {
    //                 field : field+'_suggest',
    //                 size: 10000
    //             }
    //         };
    //     }
    //   return this.http
    //             .post(this.esSearchUrl, query_suggest, this.headers)
    //             .map(response => {
    //                 return response.json();
    //             });
    // }
    
    // search(): Promise<any> { 
    //   return this.http.post(this.esSearchUrl, this.searchQuery, this.headers)
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/search-elasticsearch.service.ts